/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  APP_DESCRIPTION: {
    id: 'app.APP_DESCRIPTION',
    defaultMessage: 'APP_DESCRIPTION'
  },
  APP_INFORMATION: {
    id: 'app.APP_INFORMATION',
    defaultMessage: 'APP_INFORMATION'
  },
  ADMINISTRATION_LABEL: {
    id: 'app.ADMINISTRATION_LABEL',
    defaultMessage: 'ADMINISTRATION_LABEL'
  },
  WARNING_LABEL: {
    id: 'app.WARNING_LABEL',
    defaultMessage: 'WARNING_LABEL'
  },
  NOTIFICATION_INVITATION_SENT: {
    id: 'app.NOTIFICATION_INVITATION_SENT',
    defaultMessage: 'NOTIFICATION_INVITATION_SENT'
  },
  NOTIFICATION_FAILED: {
    id: 'app.NOTIFICATION_FAILED',
    defaultMessage: 'NOTIFICATION_FAILED'
  },
  NOTIFICATION_CANCELLED: {
    id: 'app.NOTIFICATION_CANCELLED',
    defaultMessage: 'NOTIFICATION_CANCELLED'
  },
  NOTIFICATION_PROPOSALS: {
    id: 'app.NOTIFICATION_PROPOSALS',
    defaultMessage: 'NOTIFICATION_PROPOSALS'
  },
  NOTIFICATION_RESENT: {
    id: 'app.NOTIFICATION_RESENT',
    defaultMessage: 'NOTIFICATION_RESENT'
  },
  ACCOUNT_LABEL: {
    id: 'app.ACCOUNT_LABEL',
    defaultMessage: 'ACCOUNT_LABEL'
  },
  FILE_LABEL: {
    id: 'app.FILE_LABEL',
    defaultMessage: 'FILE_LABEL'
  },
  PAYMENT_LABEL: {
    id: 'app.PAYMENT_LABEL',
    defaultMessage: 'PAYMENT_LABEL'
  },
  APPLICANT_LABEL: {
    id: 'app.APPLICANT_LABEL',
    defaultMessage: 'APPLICANT_LABEL'
  },
  LOGOUT: {
    id: 'app.LOGOUT',
    defaultMessage: 'LOGOUT'
  },
  CHANGE_PASSWORD_LABEL: {
    id: 'app.CHANGE_PASSWORD_LABEL',
    defaultMessage: 'CHANGE_PASSWORD_LABEL'
  },
  CHANGE_USER_PASSWORD_LABEL: {
    id: 'app.CHANGE_USER_PASSWORD_LABEL',
    defaultMessage: 'CHANGE_USER_PASSWORD_LABEL'
  },
  PRESTATION_MODIFICATION: {
    id: 'prestation.PRESTATION_MODIFICATION',
    defaultMessage: 'PRESTATION_MODIFICATION'
  },
  PRESTATION_MODIFICATION_DESCRIPTION: {
    id: 'prestation.PRESTATION_MODIFICATION_DESCRIPTION',
    defaultMessage: 'PRESTATION_MODIFICATION_DESCRIPTION'
  },
  CUSTOMER_NAME: {
    id: 'prestation.CUSTOMER_NAME',
    defaultMessage: 'CUSTOMER_NAME'
  },
  CUSTOMER_EMAIL: {
    id: 'prestation.CUSTOMER_EMAIL',
    defaultMessage: 'CUSTOMER_EMAIL'
  },
  CUSTOMER_PHONE: {
    id: 'prestation.CUSTOMER_PHONE',
    defaultMessage: 'CUSTOMER_PHONE'
  },
  CUSTOMER_COMMENT: {
    id: 'prestation.CUSTOMER_COMMENT',
    defaultMessage: 'CUSTOMER_COMMENT'
  },
  SEND_COMMENT: {
    id: 'prestation.SEND_COMMENT',
    defaultMessage: 'SEND_COMMENT'
  },
  CANCEL_COMMENT: {
    id: 'prestation.CANCEL_COMMENT',
    defaultMessage: 'CANCEL_COMMENT'
  },
  PRESTATION_MODIFICATION_SEND: {
    id: 'prestation.PRESTATION_MODIFICATION_SEND',
    defaultMessage: 'PRESTATION_MODIFICATION_SEND'
  },
  DASHBOARD_LABEL: {
    id: 'prestation.DASHBOARD_LABEL',
    defaultMessage: 'DASHBOARD_LABEL'
  },
  FAQ: {
    id: 'prestation.FAQ',
    defaultMessage: 'FAQ'
  },
  CGU: {
    id: 'prestation.CGU',
    defaultMessage: 'CGU'
  },
  NEW_PRESTATION_LABEL: {
    id: 'prestation.NEW_PRESTATION_LABEL',
    defaultMessage: 'NEW_PRESTATION_LABEL'
  },
  CHAT_LABEL: {
    id: 'prestation.CHAT_LABEL',
    defaultMessage: 'CHAT_LABEL'
  },
  HISTORY_LABEL: {
    id: 'prestation.HISTORY_LABEL',
    defaultMessage: 'HISTORY_LABEL'
  },
  PROPOSAL_TITLE: {
    id: 'prestation.PROPOSAL_TITLE',
    defaultMessage: 'PROPOSAL_TITLE'
  },
  PROPOSAL_ACCEPT_MESSAGE: {
    id: 'prestation.PROPOSAL_ACCEPT_MESSAGE',
    defaultMessage: 'PROPOSAL_ACCEPT_MESSAGE'
  },
  PROPOSAL_REFUSE_MESSAGE: {
    id: 'prestation.PROPOSAL_REFUSE_MESSAGE',
    defaultMessage: 'PROPOSAL_REFUSE_MESSAGE'
  },
  PRESTATION_PROPOSAL_ACCEPTED_SEND: {
    id: 'prestation.PRESTATION_PROPOSAL_ACCEPTED_SEND',
    defaultMessage: 'PRESTATION_PROPOSAL_ACCEPTED_SEND'
  },
  PRESTATION_PROPOSAL_REFUSED_SEND: {
    id: 'prestation.PRESTATION_PROPOSAL_REFUSED_SEND',
    defaultMessage: 'PRESTATION_PROPOSAL_REFUSED_SEND'
  },
  BACK_TO_LOGIN: {
    id: 'prestation.BACK_TO_LOGIN',
    defaultMessage: 'BACK_TO_LOGIN'
  },
  PRESTATION_VALIDATION_DISTANCE: {
    id: 'prestation.PRESTATION_VALIDATION_DISTANCE',
    defaultMessage: 'PRESTATION_VALIDATION_DISTANCE'
  },
  PRESTATION_VALIDATION_TITLE: {
    id: 'prestation.PRESTATION_VALIDATION_TITLE',
    defaultMessage: 'PRESTATION_VALIDATION_TITLE'
  },
  PRESTATION_VALIDATION_SEND: {
    id: 'prestation.PRESTATION_VALIDATION_SEND',
    defaultMessage: 'PRESTATION_VALIDATION_SEND'
  },
  INVITATION_ACCEPTED_SEND: {
    id: 'prestation.INVITATION_ACCEPTED_SEND',
    defaultMessage: 'INVITATION_ACCEPTED_SEND'
  },
  INVITATION_REFUSED_SEND: {
    id: 'prestation.INVITATION_REFUSED_SEND',
    defaultMessage: 'INVITATION_REFUSED_SEND'
  },
  FAQ_SANTE: {
    id: 'prestation.FAQ_SANTE',
    defaultMessage: 'FAQ_SANTE'    
  },
  FAQ_SOCIAL: {
    id: 'prestation.FAQ_SOCIAL',
    defaultMessage: 'FAQ_SOCIAL'        
  }
})



// WEBPACK FOOTER //
// ./src/constants/messages.js